import { InjectionToken } from '@angular/core';
import { CaEnvironment } from '@ca/ca-utils';

export const CA_ENVIRONMENT: InjectionToken<CaEnvironment> = new InjectionToken('CA_ENVIRONMENT');

export const SERVER_BASE_URL: InjectionToken<string> = new InjectionToken('SERVER_BASE_URL');
